export enum DraftStatuses
{
    New = 1,
    Pending = 2,
    EndOfLife = 3
}